import { Box } from 'ui';
import { css, experimentalStyled as styled, BoxProps } from '@mui/material';
import Header from './PageHeader';
import Footer from './PageFooter';
import Body from './PageBody';

interface Props extends BoxProps {
  children: JSX.Element | JSX.Element[];
}

export const PageRoot = styled(Box)<BoxProps>`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    background-color: ${theme.palette.secondary.darker};
    height: 100%;
  `}
`;

const Page = ({ children, sx }: Props) => {
  return <PageRoot sx={sx}>{children}</PageRoot>;
};

Page.Header = Header;
Page.Body = Body;
Page.Footer = Footer;

export default Page;
